/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const authResponseOutputDataSchema = z.object({
	user: z.object({
		id: z.string(),
		email: z.string(),
		firstName: z.string().nullable(),
		lastName: z.string().nullable(),
		profilePictureUrl: z.string().nullable(),
		language: z.string().default('en-GB'),
		firstLoginAt: z.iso.datetime().nullable(),
		onboardingCompletedAt: z.iso.datetime().nullable(),
		recruitingVolume: z.union([z.literal('low'), z.literal('mid'), z.literal('high'), z.literal('unknown')])
			.nullable(),
		contactsCandidates: z.boolean().nullable(),
		managesTeam: z.boolean().nullable(),
		organisationHeadcount: z.union([
			z.literal('1-10'),
			z.literal('11-50'),
			z.literal('51-200'),
			z.literal('201-500'),
			z.literal('501-1000'),
			z.literal('1000+'),
		]).nullable(),
		phoneNumber: z.string().nullable(),
		isSelfSignup: z.boolean().default(false),
		isProvisioned: z.boolean().default(true),
	}),
	accessToken: z.string(),
})

export type AuthResponseOutputDataSchema = z.infer<typeof authResponseOutputDataSchema>
